import React from "react";
import "../styles/Contact.css";

const Contact: React.FC = () => {
  const handleLocationClick = () => {
    const address =
      "3-601/2 First Floor, Pedda Golconda, Shamshabad, Hyderabad, India – 501218";
    const encodedAddress = encodeURIComponent(address);
    window.open(
      `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`,
      "_blank"
    );
  };

  const handlePhoneClick = () => {
    window.open("tel:+917207149900", "_self");
  };

  const handleEmailClick = () => {
    window.open("mailto:info@parwahindustries.com", "_self");
  };

  return (
    <section id="contact" className="contact">
      <div className="container">
        <h2>Contact Us</h2>
        <div className="contact-info">
          <div className="info-item clickable" onClick={handleLocationClick}>
            <img src="images/location.png" alt="Location" />
            <p>
              3-601/2 First Floor, Pedda Golconda, Shamshabad, Hyderabad, India
              – 501218
            </p>
          </div>
          <div className="info-item clickable" onClick={handlePhoneClick}>
            <img src="images/phone.png" alt="Phone" />
            <p>+91 7207149900</p>
          </div>
          <div className="info-item clickable" onClick={handleEmailClick}>
            <img src="images/mail.png" alt="Email" />
            <p>info@parwahindustries.com</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
